
import 'slick-carousel';

$(() => {
  $('.logo-carousel').on('init', function(event, slick){
    $('.logo-carousel').show();
  });
  var autoplaySpeed = $('.logo-carousel').data( "speed");
  $('.logo-carousel').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: autoplaySpeed,
    arrows: true,
    dots: false,
    pauseOnHover: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 520,
      settings: {
        slidesToShow: 2
      }
    }]
  });
});